import { render, staticRenderFns } from "./showAllLoyaltyMomentsCard.vue?vue&type=template&id=10f489bc&"
import script from "./showAllLoyaltyMomentsCard.vue?vue&type=script&lang=js&"
export * from "./showAllLoyaltyMomentsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports